import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import React from 'react';
import { drawerFooter, drawerHeader, drawerHeaderIcon, drawerBackdropStyle, drawerPaperStyle, drawerHeaderTitle } from './CustomDrawer.style';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CloseIcon from '@mui/icons-material/Close';
import { Z_INDEX_OVERRIDE } from '../DatesSelector/utils/constants';
export const CustomDrawerMobile = ({ dataQa, title, children, open, hasNavigation = false, hasButtonValidation = true, isInvalid = false, onToggleOpenDrawer, onSendDatas, buttonValidateLabel, onClickNavigation }) => {
    const handleSendDatas = () => {
        onSendDatas && onSendDatas();
        onToggleOpenDrawer(false);
    };
    const close = () => {
        onToggleOpenDrawer(false);
    };
    return (React.createElement(Drawer, { sx: { zIndex: Z_INDEX_OVERRIDE }, anchor: "bottom", open: open, onClose: close, "data-qa": dataQa, BackdropProps: { sx: drawerBackdropStyle }, PaperProps: { sx: drawerPaperStyle } },
        React.createElement(Box, { sx: drawerHeader },
            hasNavigation
                ? React.createElement(IconButton, { onClick: onClickNavigation },
                    React.createElement(ArrowBackIosIcon, { sx: drawerHeaderIcon }))
                : React.createElement(Box, null),
            React.createElement(Box, { sx: drawerHeaderTitle, "data-qa": `${dataQa}-title` }, title),
            React.createElement(IconButton, { onClick: close, "data-qa": `${dataQa}-close` },
                React.createElement(CloseIcon, { sx: drawerHeaderIcon }))),
        React.createElement(Box, { sx: { flex: 2 } },
            React.createElement(FormControl, { sx: { margin: 0 } }, children)),
        hasButtonValidation &&
            React.createElement(Box, { sx: drawerFooter },
                React.createElement(Button, { "data-qa": `${dataQa}-validate`, color: "secondary", variant: "contained", onClick: handleSendDatas, fullWidth: true, disabled: isInvalid }, buttonValidateLabel))));
};
